import * as tslib_1 from "tslib";
import { LightingCompositeChunk } from "./LightingCompositeChunk";
/**
 * SpecularFresnelChunk provides a specular shading method that causes stronger highlights on grazing view angles.
 */
var SpecularFresnelChunk = (function (_super) {
    tslib_1.__extends(SpecularFresnelChunk, _super);
    /**
     * Creates a new SpecularFresnelChunk object.
     */
    function SpecularFresnelChunk(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        _this._method = method;
        _this._shader = shader;
        _this._baseChunk._modulateFunction = function (targetReg, registerCache, sharedRegisters) { return _this.modulateSpecular(targetReg, registerCache, sharedRegisters); };
        return _this;
    }
    /**
     * @inheritDoc
     */
    SpecularFresnelChunk.prototype._cleanCompilationData = function () {
        _super.prototype._cleanCompilationData.call(this);
        this._fresnelDataRegister = null;
    };
    /**
     * @inheritDoc
     */
    SpecularFresnelChunk.prototype._activate = function () {
        _super.prototype._activate.call(this);
        if (this._invalid) {
            var data = this._shader.fragmentConstantData;
            var index = this._fresnelDataIndex;
            data[index] = this._method.normalReflectance;
            data[index + 1] = this._method.fresnelPower;
            data[index + 2] = 1;
            data[index + 3] = 0;
        }
    };
    /**
     * @inheritDoc
     */
    SpecularFresnelChunk.prototype._getFragmentPreLightingCode = function (registerCache, sharedRegisters) {
        this._fresnelDataRegister = registerCache.getFreeFragmentConstant();
        this._fresnelDataIndex = this._fresnelDataRegister.index * 4;
        return _super.prototype._getFragmentPreLightingCode.call(this, registerCache, sharedRegisters);
    };
    /**
     * Applies the fresnel effect to the specular strength.
     *
     * @param vo The MethodVO object containing the method data for the currently compiled material pass.
     * @param target The register containing the specular strength in the "w" component, and the half-vector/reflection vector in "xyz".
     * @param regCache The register cache used for the shader compilation.
     * @param sharedRegisters The shared registers created by the compiler.
     * @return The AGAL fragment code for the method.
     */
    SpecularFresnelChunk.prototype.modulateSpecular = function (targetReg, registerCache, sharedRegisters) {
        var code;
        code = "dp3 " + targetReg + ".y, " + sharedRegisters.viewDirFragment + ".xyz, " + (this._method.basedOnSurface ? sharedRegisters.normalFragment : targetReg) + ".xyz\n" +
            "sub " + targetReg + ".y, " + this._fresnelDataRegister + ".z, " + targetReg + ".y\n" +
            "pow " + targetReg + ".x, " + targetReg + ".y, " + this._fresnelDataRegister + ".y\n" +
            "sub " + targetReg + ".y, " + this._fresnelDataRegister + ".z, " + targetReg + ".y\n" +
            "mul " + targetReg + ".y, " + this._fresnelDataRegister + ".x, " + targetReg + ".y\n" +
            "add " + targetReg + ".y, " + targetReg + ".x, " + targetReg + ".y\n" +
            "mul " + targetReg + ".w, " + targetReg + ".w, " + targetReg + ".y\n";
        return code;
    };
    return SpecularFresnelChunk;
}(LightingCompositeChunk));
export { SpecularFresnelChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/SpecularFresnelChunk.js